import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InArrayPipe } from './in-array.pipe';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        InArrayPipe,
    ],
    providers: [],
    exports: [
        InArrayPipe,
    ]
})
export class InArrayPipeModule {}
